export default __webpack_public_path__ + "static/media/third-section-bg-mbl.5a40b77f.png";